import { useMemo } from 'react';

import { useRouteParams } from 'routes';

import { Tabs, Column } from 'components/Blocks';

import { ProjectExecution } from './Execution';
import { Invoice } from './Invoice';
import { FinishProject } from './FinishProject';
import { Issues } from './Issues';
import { RecruitmentTab } from './Recruitment';
import { ProjectTrackerList } from './Tracking';

import { LoadingProject } from './Loading';
import { BadProjectIdGuard } from './BadId';
import { ProjectHeader } from './Header';

import { useProjectProfile } from './context';
import { ProjectProfileProvider } from './context/Provider';

import { useUser } from 'hooks/user';

import { getProjectActiveTabs, Tab } from './tabs';

const tabComponents: { [key in Tab]: typeof ProjectExecution } = {
  execution: ProjectExecution,

  invoice: Invoice,

  issues: Issues,

  recruitments: RecruitmentTab,

  finish: FinishProject,

  tracking: ProjectTrackerList,
};

function ProjectProfileBase() {
  const user = useUser();
  const { project, loading, tab, setTab } = useProjectProfile();

  const tabs = getProjectActiveTabs(project, user).filter((t) => t.render ?? true);

  const View = useMemo(() => tabComponents[tab], [tab]);

  if (loading || !project) return <LoadingProject />;

  return (
    <Column gap="2" fullHeight>
      <ProjectHeader />

      <div>
        <Tabs
          tabs={tabs}
          value={tab}
          onTabChange={(newTab) => setTab(newTab as Tab)}
          className="relative z-[2] -ml-1"
          responsiveBreakpoint="PHONE"
        />

        <hr className="relative z-[1] -translate-y-1 phone:-translate-y-0" />
      </div>
      <View />
    </Column>
  );
}

function ProjectProfile() {
  const { projectId } = useRouteParams('projectProfile');

  return (
    <BadProjectIdGuard>
      <ProjectProfileProvider key={projectId}>
        <ProjectProfileBase />
      </ProjectProfileProvider>
    </BadProjectIdGuard>
  );
}

export default ProjectProfile;
